export const AUTH_TYPE = {
  APPLE: 'apple',
  LINKED_IN: 'linkedin',
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
};
